import { Box, Button, IconButton, Menu, Typography } from "@mui/material";
// import FilterControl from "../../../shared/FilterControl/FilterControl";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterControl from "../FilterControl/FilterControl";

export default function OperatorsTableActionBar({
  title,
  options,
  sortBy,
  onSortChange,
  sortOrderLabel,
  onSortOrderClick,
  onConfigClick,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      {/* Left side */}
      <Typography variant="h6">{title}</Typography>

      {/* Right side */}
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <FilterControl
          setSortBy={onSortChange}
          options={options}
          sortBy={sortBy}
        />

        <Button
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            borderColor: "#172036",
            borderRadius: "4px",
            px: 1.5,
            height: 36,
            borderWidth: 1,
          }}
          onClick={onSortOrderClick}
        >
          <Box display="flex" flexDirection="column">
            <KeyboardArrowUpIcon
              fontSize="small"
              sx={{
                height: "13px",
                color:
                  sortOrderLabel === "Зростання" ? "primary.main" : "grey.400",
              }}
            />
            <KeyboardArrowDownIcon
              fontSize="small"
              sx={{
                height: "13px",
                color:
                  sortOrderLabel === "Спадання" ? "primary.main" : "grey.400",
              }}
            />
          </Box>
          {sortOrderLabel}
        </Button>

        {/* Кнопка конфигурации */}
        <Button
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            borderColor: "#172036",
            borderRadius: "4px",
            px: 1.5,
            height: 36,
            borderWidth: 1,
          }}
          onClick={onConfigClick}
        >
          {" "}
          <SettingsIcon />
        </Button>
      </Box>
    </Box>
  );
}
